import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack, Typography } from "@mui/material";
import Surtitle from "@project/components/Surtitle";
import React from "react";
const SectionHeader = ({ title, surtitle, description, contrast = false, sx, }) => {
    return (_jsxs(Stack, { direction: { xs: "column", md: "row" }, spacing: { xs: 2, md: 5 }, sx: {
            justifyContent: "space-between",
            alignItems: "flex-start",
            marginBottom: { xs: 3, md: 6 },
            ...sx,
        }, children: [_jsxs(Stack, { spacing: 2, sx: { maxWidth: 690, flex: 1 }, children: [_jsx(Surtitle, { title: surtitle, contrast: contrast }), _jsx(Typography, { component: "h2", variant: "h2", sx: {
                            color: contrast ? "primary.contrastText" : "text.primary",
                        }, children: title })] }), description && (_jsx(Box, { sx: {
                    maxWidth: 570,
                    flex: 1,
                    alignSelf: { xs: "auto", md: "flex-end" },
                }, children: _jsx(Typography, { variant: "body1", sx: {
                        color: contrast ? "primary.contrastText" : "text.secondary",
                        fontSize: { xs: "14px", md: "16px" },
                        lineHeight: { xs: "150%", md: "160%" },
                    }, children: description }) }))] }));
};
export default SectionHeader;
